import { diContainer, serviceNames } from '../../../diContainer/diContainer';
import BaseNotificationManager  from './BaseNotificationManager';
import AfterpayNotificationManager from './AfterpayNotificationManager';

export const notificationServicesNames = {
  afterpayNotification: 'afterpayNotification',
};

let isLoaded = false;

export const initializeNotificationManagers = (): void => {
  if (isLoaded) {
    return;
  }

  diContainer.
    register(notificationServicesNames.afterpayNotification, c => new AfterpayNotificationManager({
      billingRepository: c.get(serviceNames.billingRepository),
      configRepository: c.get(serviceNames.configRepository),
      notificationsCollection: c.get(serviceNames.notificationsCollection),
      transactionRepository: c.get(serviceNames.transactionRepository),
    }));

  Object.values(notificationServicesNames).forEach(service => {
    (diContainer.get(service) as BaseNotificationManager).init();
  });

  isLoaded = true;
};
